import { 
    Wrench,
    Palette,
    Search,
    Calendar,
    ArrowRight
} from "lucide-react";
import { Button } from "@/components/ui/button";

const SERVICES = [
    {
        id: "optimization",
        title: "Done-For-You Optimization",
        description: "We implement the fixes for you",
        icon: Wrench,
        color: "violet"
    },
    {
        id: "redesign",
        title: "Full Website Redesign",
        description: "Complete design overhaul",
        icon: Palette,
        color: "cyan"
    },
    {
        id: "seo",
        title: "SEO Setup & Local Optimization",
        description: "Get found by more customers",
        icon: Search,
        color: "emerald"
    }
];

// Microsoft Bookings scheduling link
const SCHEDULING_LINK = "https://outlook.office.com/book/SiteGradeProConsultations@KameldasDesignsLLC.onmicrosoft.com/";

export default function ServicesPromo({ onBookService }) {
    const handleServiceClick = (serviceId) => {
        if (onBookService) {
            onBookService(serviceId);
        } else {
            // Default: open scheduling link in new tab
            window.open(SCHEDULING_LINK, '_blank');
        }
    };

    return (
        <div className="mt-12 pt-10 border-t border-white/5" data-testid="services-promo">
            {/* Subtle header */}
            <div className="text-center mb-8">
                <p className="text-xs uppercase tracking-widest text-gray-500 mb-2">
                    Need Expert Help?
                </p>
                <h3 className="text-xl font-semibold text-white">
                    Want Us To Fix This For You?
                </h3>
            </div>

            {/* Service buttons */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                {SERVICES.map((service) => {
                    const Icon = service.icon;
                    return (
                        <button
                            key={service.id}
                            onClick={() => handleServiceClick(service.id)}
                            className={`group relative p-4 bg-white/[0.02] hover:bg-white/[0.05] border border-white/10 hover:border-white/20 rounded-lg transition-all text-left`}
                            data-testid={`service-${service.id}-btn`}
                        >
                            <div className="flex items-start gap-3">
                                <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${
                                    service.color === 'violet' ? 'bg-violet-500/10 border border-violet-500/20' :
                                    service.color === 'cyan' ? 'bg-cyan-500/10 border border-cyan-500/20' :
                                    'bg-emerald-500/10 border border-emerald-500/20'
                                }`}>
                                    <Icon className={`h-4 w-4 ${
                                        service.color === 'violet' ? 'text-violet-400' :
                                        service.color === 'cyan' ? 'text-cyan-400' :
                                        'text-emerald-400'
                                    }`} />
                                </div>
                                <div className="flex-1 min-w-0">
                                    <p className="text-sm font-medium text-white group-hover:text-gray-100 truncate">
                                        {service.title}
                                    </p>
                                    <p className="text-xs text-gray-500 mt-0.5 truncate">
                                        {service.description}
                                    </p>
                                </div>
                            </div>
                        </button>
                    );
                })}
            </div>

            {/* Scheduling link */}
            <div className="mt-6 text-center">
                <button
                    onClick={() => window.open(SCHEDULING_LINK, '_blank')}
                    className="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors"
                    data-testid="schedule-call-link"
                >
                    <Calendar className="h-4 w-4" />
                    <span>Schedule a free strategy call</span>
                    <ArrowRight className="h-3 w-3 opacity-50" />
                </button>
            </div>
        </div>
    );
}
